import { safeLocalStorage } from '@zealot/shared/browser';
import { STORAGE_KEYS } from './constants';

// gloss
const tokenSignature = (token: string | null | undefined): string | null => token?.split('.')[2] || null;

// gloss
const UNUSABLE_URL_TOKEN = 'unusable';

// gloss
export const markEmbedUrlSession = (token: string) =>
  safeLocalStorage.setItem(STORAGE_KEYS.EMBED_URL_SESSION, tokenSignature(token) ?? UNUSABLE_URL_TOKEN);

// gloss
export const clearEmbedUrlSession = () => safeLocalStorage.removeItem(STORAGE_KEYS.EMBED_URL_SESSION);

// gloss
export const hasEmbedUrlSession = (): boolean =>
  typeof window !== 'undefined' && Boolean(safeLocalStorage.getItem(STORAGE_KEYS.EMBED_URL_SESSION));

// gloss
export const getStoredEmbedUrlSessionToken = (): string | null => {
  if (typeof window === 'undefined') return null;
  const stored = safeLocalStorage.getItem(STORAGE_KEYS.MAGIC_TOKEN);
  return stored && isEmbedUrlSessionToken(stored) ? stored : null;
};

// gloss
export const isEmbedUrlSessionToken = (token: string): boolean => {
  const marker = safeLocalStorage.getItem(STORAGE_KEYS.EMBED_URL_SESSION);
  return Boolean(marker) && tokenSignature(token) === marker;
};
